import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-muted-foreground mb-8">Last updated: January 2026</p>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
              <p className="text-foreground/90 leading-relaxed">
                CallChat ("we", "our", or "us") is committed to protecting your privacy and is fully GDPR compliant. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered phone assistant service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
              <p className="text-foreground/90 leading-relaxed mb-3">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc list-inside space-y-2 text-foreground/90 ml-4">
                <li>Business contact information (name, email, phone number)</li>
                <li>Call data and transcripts</li>
                <li>Appointment and scheduling information</li>
                <li>Payment and billing information</li>
                <li>Usage data and analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
              <p className="text-foreground/90 leading-relaxed mb-3">
                We use the collected information to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-foreground/90 ml-4">
                <li>Provide and maintain our AI call handling services</li>
                <li>Process appointments and bookings</li>
                <li>Send notifications and service updates</li>
                <li>Improve our AI models and service quality</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. GDPR Compliance</h2>
              <p className="text-foreground/90 leading-relaxed">
                SmartCall AI is fully GDPR-compliant. All data is hosted in Belgian data centers. You have the right to access, rectify, erase, restrict processing, and port your data. To exercise these rights, contact us at hello@smartcall.be.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Data Security</h2>
              <p className="text-foreground/90 leading-relaxed">
                We implement industry-standard security measures to protect your data, including encryption in transit and at rest, regular security audits, and access controls.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Data Retention</h2>
              <p className="text-foreground/90 leading-relaxed">
                We retain your data for as long as necessary to provide our services and comply with legal obligations. Call transcripts are retained for 12 months unless otherwise specified.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Third-Party Services</h2>
              <p className="text-foreground/90 leading-relaxed">
                We may use third-party services for payment processing and analytics. These services are carefully selected and comply with GDPR requirements.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Contact Us</h2>
              <p className="text-foreground/90 leading-relaxed">
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-secondary/30 rounded-lg">
                <p className="text-foreground/90">Email: hello@smartcall.be</p>
                <p className="text-foreground/90">Address: Brussels, Belgium</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
